import Component from '@bythepixel/component-loader';
import { eventThrottle } from '@Core/utility';

const cssClasses = {
  subNavVisible: 'section-sub-nav-homepage--visible',
};

export default class SectionSubNavProductDetails extends Component {
  static selector = '[data-comp-section-sub-nav-homepage]';

  constructor(el) {
    super(el);
    this.borderedCtas = document.querySelector('.section-bordered-ctas-advanced');
    this.observeBorderedCtas();

    window.addEventListener('resize', eventThrottle(() => {
      const { innerWidth } = window;
      const navVisible = this.$container.classList.contains(cssClasses.subNavVisible);
      if (innerWidth > 908 && navVisible) {
        this.$container.classList.remove(cssClasses.subNavVisible);
      }
    }));
  }

  observeBorderedCtas() {
    if (!this.borderedCtas) {
      return;
    }
    const options = {
      threshold: 0,
      rootMargin: '0px 0px -100% 0px',
    };

    const watchCtas = entries => {
      const entry = entries[0];
      const { innerWidth } = window;
      const { intersectionRatio, isIntersecting } = entry;
      const navShouldShow = intersectionRatio === 0 && isIntersecting && !this.isVisible();

      if (innerWidth > 908) return;

      if (navShouldShow) {
        this.$container.classList.add(cssClasses.subNavVisible);
      } else {
        this.$container.classList.remove(cssClasses.subNavVisible);
      }
    };

    const observer = new IntersectionObserver(watchCtas, options);
    observer.observe(this.borderedCtas);
  }

  isVisible() {
    return this.$container.classList.contains(cssClasses.subNavVisible);
  }
}
